module.exports = __webpack_public_path__ + "static/img_pledge_02@2x-314879f814ef12affa53f2b87f9f5e3f.png";